const modal = ({
  action, name, settings = {}, payload = null,
}, vm) => {
  if (!action || !name) return

  vm.$modal.open(name, settings, payload)
}

const navigation = ({ name, path }, vm) => {
  if (path) {
    vm.$router.push(path).catch(() => {})
  } else if (name) {
    vm.$router.push({ name }).catch(() => {})
  }
}

const navigationExternal = ({ link, newTab }, vm) => {
  if (newTab) {
    const tab = window.open(link, '_blank', 'noopener,noreferrer')

    if (tab) tab.focus()
  } else {
    document.location.href = link
  }
}

export default {
  modal,
  navigation,
  navigationExternal,
}
